import { httpClient } from '@invent/platform-api';
import type { IWidgetMetadata, IPortalSettingsStore } from './types';

const TRACE_ID = '375efc5b-9e22-4f16-a8a9-f51dd822ce52';

export function getWidgets(
  widgetsType: 'public' | 'private',
  tenentId: string
): Promise<IWidgetMetadata[]> {
  return httpClient(`${window.WIDGET_STORE_API_URL}/my/widgets/${widgetsType}`, {
    traceId: `${TRACE_ID}--1`,
    headers: { 'x-tenent-id': tenentId }
  });
}

export function getTenantId() {
  return httpClient<{ tenentId: string }>(`${window.CUSTOMIZATION_BE}/tenent`, {
    traceId: `${TRACE_ID}--2`
  });
}

export function getPortalSettings() {
  return httpClient<IPortalSettingsStore>(`${window.CUSTOMIZATION_BE}/portal/config`, {
    traceId: `${TRACE_ID}--5`
  });
}
